export const META_PIXEL_ID = '1030852003175468'
export const META_PURCHASE_STORAGE_KEY = 'meta_pixel_pending_purchase'

const PUBLIC_EXACT = new Set([
  '/',
  '/nosotros',
  '/contacto',
  '/carrito',
  '/carrito/success',
  '/carrito/error-pago',
  '/cuenta/login',
  '/cuenta/registro',
  '/login',
  '/mis-tickets',
])

/**
 * Solo rutas de la web pública (no dashboard admin).
 */
export const isPublicMarketingPath = (pathname = '') => {
  const folder = typeof window !== 'undefined' ? (window.pathFolder || '') : ''
  let path = pathname || '/'
  if (folder && path.startsWith(folder)) {
    path = path.slice(folder.length) || '/'
  }
  path = path.replace(/\/+$/, '') || '/'

  if (PUBLIC_EXACT.has(path)) return true
  if (path.startsWith('/evento/')) return true
  if (path.startsWith('/cuenta/')) return true
  if (path.startsWith('/mis-tickets')) return true
  if (path.startsWith('/productos')) return true
  if (path.startsWith('/carrito-productos')) return true
  return false
}

export const trackMeta = (eventName, params) => {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') {
    return
  }
  if (params) {
    window.fbq('track', eventName, params)
  } else {
    window.fbq('track', eventName)
  }
}

export const trackMetaPageView = () => trackMeta('PageView')

export const trackMetaViewContent = (params = {}) => {
  trackMeta('ViewContent', params)
}

export const trackMetaInitiateCheckout = (params = {}) => {
  trackMeta('InitiateCheckout', params)
}

export const trackMetaLead = (params = {}) => {
  trackMeta('Lead', params)
}

export const trackMetaPurchase = ({ value, currency = 'MXN', ...rest } = {}) => {
  const payload = { currency, ...rest }
  if (value !== undefined && value !== null && value !== '') {
    const num = parseFloat(value)
    if (!isNaN(num)) {
      payload.value = num
    }
  }
  trackMeta('Purchase', payload)
}

export const savePendingPurchase = ({ value, currency = 'MXN' }) => {
  try {
    sessionStorage.setItem(
      META_PURCHASE_STORAGE_KEY,
      JSON.stringify({
        value: parseFloat(value) || 0,
        currency,
        ts: Date.now(),
      })
    )
  } catch (_) {
    /* ignore */
  }
}

export const consumePendingPurchase = () => {
  try {
    const raw = sessionStorage.getItem(META_PURCHASE_STORAGE_KEY)
    if (!raw) return null
    sessionStorage.removeItem(META_PURCHASE_STORAGE_KEY)
    return JSON.parse(raw)
  } catch (_) {
    return null
  }
}
